import React from 'react';
import interpolate from '../utils/interpolate';
import { capitalizeFirstLetter } from '../utils/utils';

export const SearchResult = (props) => {
  let data = props.data;

  if (props.dataSource.sourceType !== 'jira') {
    if (props.data) {
      data = interpolate(props.valueExpression, { item: props.data });
    } else {
      data = '';
    }
  }

  let additionalData = '';
  if (props.additionalTargetField && props.additionalValueExpression && props.data) {
    additionalData = interpolate(props.additionalValueExpression, { item: props.data });
  }

  const resultExpression = props.resultExpression;
  const resultFields = resultExpression.split(',');

  if (!props.resultExpression)
    return (
      <div>
        <input type='hidden' id='location' name='location' value={data}></input>
        <input type='hidden' id='additionalLocation' name='additionalLocation' value={additionalData}></input>
      </div>
    );
  return (
    <div>
      <input type='hidden' id='location' name='location' value={data}></input>
      <input type='hidden' id='additionalLocation' name='additionalLocation' value={additionalData}></input>

      {props.dataSource.sourceType !== 'jira' ? (
        <table className='aui' style={{ fontSize: '12px' }}>
          <thead style={{ fontSize: '12px', color: '#5e6c84' }}>
            <tr>
              {resultFields.map((field) => {
                return <th>{capitalizeFirstLetter(field)}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            <tr>
              {resultFields.map((field, index) => {
                const value = props.data[field];
                let displayValue;

                if (value === null || value === undefined) {
                  displayValue = '';
                } else if (typeof value === 'object' && value !== null) {
                  if (Array.isArray(value)) {
                    displayValue = value.join(', ');
                  } else if (value instanceof Date) {
                    displayValue = value.toLocaleString();
                  } else {
                    displayValue = JSON.stringify(value);
                  }
                } else {
                  displayValue = String(value);
                }

                return <td key={index}>{displayValue}</td>;
              })}
            </tr>
          </tbody>
        </table>
      ) : null}
    </div>
  );
};
